/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
const initialState = {
  tagFilter: null,
  severityReport: null,
  equipReport: null,
  modelReport: null,
  checklistReport: null,
  filterReport: null,
  issueGalleryList: null,
  issueGalleryFilterList: null,
  isHSSE: false,
  filterPreference: null,
  filterResponse: false,
  galleryPDFData: null,
};

const issuegalleryReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'filterResponse':
      return {
        ...state,
        filterResponse: action.value,
      };
    case 'PREFERENCE':
      return {
        ...state,
        filterPreference: action.value,
      };
    case 'TAG_FILTER':
      return {
        ...state,
        tagFilter: action.value,
      };
    case 'severityFilter':
      return {
        ...state,
        severityReport: action.value,
      };
    case 'equipFilter':
      return {
        ...state,
        equipReport: action.value,
      };
    case 'modelFilter':
      return {
        ...state,
        modelReport: action.value,
      };
    case 'checklistFilter':
      return {
        ...state,
        checklistReport: action.value,
      };
    case 'reportFilter':
      return {
        ...state,
        filterReport: action.value,
      };
    case 'GET_ISSUE_GALLERY':
      return {
        ...state,
        issueGalleryList: action.value,
      };
    case 'GET_ISSUE_GALLERY_Filter':
      return {
        ...state,
        issueGalleryFilterList: action.value,
      };
    case 'IS_HSSS':
      return {
        ...state,
        isHSSE: action.value,
      };
    case 'GALLERY_PDF_DATA':
      return {
        ...state,
        galleryPDFData: action.value,
      };
    default:
      return state;
  }
};

export default issuegalleryReducer;
